import cookie from 'js-cookie'
import { assign, cloneDeep } from 'lodash'

export const defaultSettings = {
  feature: 'default',
  chargeSettings: {
    is_snap_pop_up: true,
    expiry: 'default',
    user_id: 'normal',
    authentication: '3ds',
    installment_use: 'disabled',
    installment_terms: [],
    credit_card_bank: null,
    credit_card_bni_whitelist_bins: null,
    credit_card_mandiri_whitelist_bins: null,
    credit_card_type: 'authorize_capture',
    bni_va_number: null,
    bca_va_number: null,
    permata_va_number: null,
    bri_va_number: null,
    cimb_va_number: null,
    danamon_va_number: null,
    use_merchant_keys: false,
    enabled_payments_use: false,
    enabled_payments: null,
    gopay_user_id: null,
    use_custom_bank_list: false,
    bank_enabled_payments: null,
  },
  gopayUnbindSettings: {
    gopay_phone_number: null,
    loading: false,
    unbindSuccess: false,
    unbindMessages: null,
  }
}

export function fetch () {
  try {
    return assign(cloneDeep(defaultSettings), JSON.parse(cookie.get('paymentSettings')))
  } catch (e) {
    return cloneDeep(defaultSettings)
  }
}

export function store (settings) {
  try {
    cookie.set('paymentSettings', JSON.stringify(settings))
  } catch (e) {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/js/store/settings.js